import React, { useEffect, useState } from "react";
import { ProjectList } from "../../common/ProjectList";
import { getProjectsByType } from "../../utils/api";
import { mergeCssClass } from "../../utils/helpers";

const useGetProjects = () => {
  const [projects, setProjects] = useState([]);

  useEffect(() => {
    getProjectsByType("visualisation").then(({ projects }) => {
      setProjects(projects);
    });
  }, []);

  return projects;
};

export const VisualisationProjects = ({ setProject }) => {
  const projects = useGetProjects();

  return (
    <div className="portfolio-projects-container">
      <div
        className={mergeCssClass(
          "portfolio-back-circle",
          "portfolio-back-circle--to-right"
        )}
      />
      <div className="portfolio-projects">
        <div
          className={mergeCssClass(
            "portfolio-projects__container",
            "portfolio-projects__residential-container",
            "portfolio-projects__container--active"
          )}
        >
          <ProjectList
            projects={projects}
            description="scroll to see more"
            setProject={setProject}
          />
        </div>
      </div>
    </div>
  );
};
